import React from 'react'
import { TableRow, TableCell, Box, withStyles } from '@material-ui/core'
import { Icon } from '@iconify/react'
import checkmarkFill from '@iconify-icons/eva/checkmark-fill'
import styles from './styles'

const renderCell = (value, classes) => {
  if (value === 'true') {
    return (
      <Box
        component={Icon}
        icon={checkmarkFill}
        className={classes.tableBox}
      />
    )
  }
  return <div>{value}</div>
}

const TableRowComponent = props => {
  const { row, activeKeys, classes } = props
  return (
    <TableRow>
      <TableCell className={classes.rootTableCell2}>{row.name}</TableCell>
      {activeKeys.map(key => (
        <TableCell key={key} className={classes.rootTableCell}>
          {renderCell(row[key], classes)}
        </TableCell>
      ))}
    </TableRow>
  )
}

export default withStyles(styles)(TableRowComponent)
